import React, { useState, useEffect, useCallback } from 'react'
import * as d3 from 'd3'
import { cerealesColor, CEREALES } from '../../../config/cereales'
import { Row, Col } from 'react-bootstrap'
import { Switch, FormControlLabel } from '@material-ui/core'

function BarChart (props) {
  const { setCalleDeCalado } = props
  const [showOrdenSalida, setShowOrdenSalida] = useState(false)

  const createChart = useCallback(() => {
    d3.select('#chart-container').selectAll('*').remove()
    const margin = { top: 20, rigth: 30, bottom: 20, left: 30 }
    const width = props.width - margin.left - margin.rigth
    const height = props.height - margin.top - margin.bottom
    const h = props.height

    const svg = d3.select('#chart-container')
      .append('svg')
      .attr('width', width + 100)
      .attr('height', height)

    const data = props.data
    const calificacionCalles = props.calificacionCalles
    const capacidadMaximaCalleCalado = 12

    const calles = data.map((d) => {
      return d[0]
    })
    const utilizado = data.map((d) => {
      return d[1]
    })
    const colorCereal = data.map((d) => {
      return d[2]
    })

    const getColor = (d) => {
      return colorCereal[d]
    }

    const capacidad = data.map((d) => {
      return d[4]
    })

    // Para asignar numeros de las calles 50+
    const numeroCalle = (i) => {
      if (i < 20) {
        return i
      }
      if (i > 19) {
        return i + 30
      }
    }

    // Filtro por calle y cargo las calificaciones con sus cantidades
    const calificacionPorCalle = (d, c) => {
      if (calificacionCalles) {
        const filtrado = calificacionCalles.filter(i => i.calleDeCalado === d)
        const tooltipText = []

        tooltipText.push([`Calle ${d}`])
        if (c === 'null') {
          tooltipText.push([
            `\n SIN ASIGNAR CEREAL`
          ])
        } else {
          tooltipText.push([
            ` --  ${c}`
          ])
        }
        if (filtrado) {
          filtrado.forEach(i => {
            const calificacion = i.calificacionCereal
            const cantidad = i.count
            tooltipText.push([
              `\n ${cantidad} ${calificacion}`
            ])
          })
        }

        if (props.camionesCalados) {
          const camionesDeCalle = props.camionesCalados.filter(i => i.calleDeCalado === d)
          const camCalleAutoDescagables = camionesDeCalle.filter(c => c.autodescargable)
          if (camCalleAutoDescagables.length > 0) {
            tooltipText.push([
              `\n ${camCalleAutoDescagables.length} Autodescargables`
            ])
          }

          tooltipText.push([
            `\n`
          ])

          camionesDeCalle.forEach(i => {
            const camion = i.camion
            const calificacionCereal = (i.estadoAutorizacion === 'Pendiente' && c === 'CEBADACE') ? ' ' : ` | ${i.calificacionCereal} `
            const estadoAutorizacion = (i.estadoAutorizacion === 'Pendiente') ? ` | ${i.estadoAutorizacion}` : ' '
            const autodescargable = (i.autodescargable) ? ' | Autodescargable' : ' '
            tooltipText.push([
              `\n ${camion}  ${calificacionCereal}   ${estadoAutorizacion} ${autodescargable}`
            ])
          })
        }
        return tooltipText.join(' ')
      }
    }

    const claveCereales = CEREALES.filter(cereal => cereal !== 'PELLETSJ' && cereal !== 'PELLETGC')

    const chart = svg.append('g').attr('transform', `translate(25, 30)`)

    const xAxis = d3.scaleBand()
      .range(props.xRange)
      .domain(calles)

    const yAxis = d3.scaleLinear()
      .range(props.yRange)
      .domain([capacidadMaximaCalleCalado, 0])

    // Tooltip
    const tooltip = d3.selectAll('body').append('div')
      .data(data)
      .attr('class', 'tooltip-barchart')
      .style('z-index', '10000')
      .style('visibility', 'hidden')
      .style('background', '#000000')
      .style('color', '#ffffff')
      .style('white-space', 'pre-line')

    const margenTooltip = 5

    // Barras capacidad

    chart.selectAll('bar')
      .data(capacidad)
      .enter()
      .append('rect')
      .style('fill', 'rgb(251 247 247)')
      .on('mouseenter', function (bar, i) {
        d3.select()
          .transition()
          .duration(600)
          .style('fill', 'rgb(224 224 224)')
      })
      .on('mouseover', function () {
        // d3.select('#mytooltip')
        //  .style('visibility', 'visible')
      })
      .on('mousemove', function () {
        tooltip.style('top', (d3.event.pageY - margenTooltip) + 'px')
          .style('left', (d3.event.pageX + margenTooltip) + 'px')
      })
      .on('mouseleave', function (bar, i) {
        tooltip.style('visibility', 'hidden')
        d3.select()
          .transition()
          .duration(600)
          .style('fill', 'rgb(251 247 247)')
          .style('stroke', 'none')

        chart.selectAll('#limit').remove()
      })
      .on('mouseout', function () {
        tooltip.style('visibility', 'hidden')
      })
      .on('click', function (bar, i) {
        const calleSeleccionada = numeroCalle(i + 1)
        const cerealCalleSeleccionada = data[i][4]
        const capacidadOcupada = data[i][1]
        tooltip.style('visibility', 'visible')
        tooltip.text(calificacionPorCalle(calleSeleccionada, cerealCalleSeleccionada))
        setCalleDeCalado(calleSeleccionada, cerealCalleSeleccionada, capacidadOcupada)

        d3.select()
          .style('fill', 'rgb(224 224 224)')
      })
      .attr('x', (d, i) => (xAxis.bandwidth()) * i)
      .attr('y', (s) => yAxis(s))
      .attr('height', (d) => h - 100)
      .attr('width', xAxis.bandwidth() - 2)

    // Barras
    chart.selectAll('bar')
      .data(utilizado)
      .enter()
      .append('rect')
      .style('fill', (d, i) => getColor(i))
      .style('opacity', 100)
      .on('mouseenter', function (bar, i) {
        d3.select()
          .transition()
          .duration(300)
          .style('fill', getColor(i))
          .style('stroke', '#ffffff')
          .style('opacity', 0.8)

        // const y = yAxis(bar)
      })
      .on('mouseover', function () {
        d3.select('#mytooltip')
          .style('visibility', 'hidden')
      })
      .on('mousemove', function () {
        tooltip.style('top', (d3.event.pageY - margenTooltip) + 'px')
          .style('left', (d3.event.pageX + margenTooltip) + 'px')
      })
      .on('mouseleave', function (bar, i) {
        d3.select()
          .transition()
          .duration(300)
          .style('fill', getColor(i))
          .style('stroke', 'none')
          .style('opacity', 100)

        chart.selectAll('#limit').remove()
      })
      .on('mouseout', function () {
        tooltip.style('visibility', 'hidden')
      })
      .on('click', function (bar, i) {
        const calleSeleccionada = numeroCalle(i + 1)
        const cerealCalleSeleccionada = data[i][4]
        const capacidadOcupada = data[i][1]
        tooltip.style('visibility', 'visible')
        tooltip.text(calificacionPorCalle(calleSeleccionada, cerealCalleSeleccionada))
        setCalleDeCalado(calleSeleccionada, cerealCalleSeleccionada, capacidadOcupada)

        d3.select()
          .style('fill', getColor(i))
          .style('stroke', '#ffffff')
          .style('opacity', 0.8)
      })

      .attr('x', (d, i) => (xAxis.bandwidth()) * i)
      .attr('width', (xAxis.bandwidth()) - 2)
      .transition()
      .duration(800)
      .attr('y', 0)
      .attr('height', (d) => yAxis(d))
      .delay((i) => (i * 50))

    chart.append('g')
      .call(d3.axisLeft(yAxis))

    chart.append('g')
      .attr('transform', `translate(0, ${props.yRange[0]})`)
      .call(d3.axisBottom(xAxis))

    chart.append('g')
      .attr('class', 'grid')
      .attr('y1', 0)
      .attr('y2', height)
      .call(d3.axisBottom()
        .scale(xAxis)
        .tickSize(height - 20, 0, 0)
        .tickFormat(''))

    chart.append('g')
      .attr('class', 'grid')
      .call(d3.axisLeft()
        .scale(yAxis)
        .tickSize(-width, 10, 10)
        .tickFormat(''))

    // Prioridad de salida
    showOrdenSalida &&
      chart.selectAll('.text-prioridad')
        .data(data)
        .enter()
        .append('text')
        .attr('class', 'text-prioridad')
        .text(d => (d[1] > 0 && d[6]) ? `${d[6]}º` : '')
        .attr('x', (d, i) => (xAxis.bandwidth() * i) + (xAxis.bandwidth() / 2))
        .attr('y', d => {
          const posVal = yAxis(d[1])
          return posVal > (h - 130) ? posVal - 5 : posVal + 20
        })
        .attr('text-anchor', 'middle')
        .style('fill', d => {
          return yAxis(d[1]) > (h - 130) ? '#333' : '#3B3B3B'
        })
        .style('font-size', '16px')
        .style('font-weight', '900')
        .style('pointer-events', 'none')

    // Legend
    const legend = svg.selectAll('.legend')
      .data(claveCereales)
      .enter().append('g')
      .attr('class', 'legend')
      .attr('transform', (d, i) => 'translate(' + (i + 4) * (35) + ',' + (0) + ')')

    legend.append('rect')
      .attr('x', (d, i) => ((xAxis.bandwidth() + 70) * i) - 18)
      .attr('width', 18)
      .attr('height', 18)
      .style('fill', function (d) { return cerealesColor[d] })

    legend.append('text')
      .attr('x', (d, i) => ((xAxis.bandwidth() + 70) * i) - 24)
      .attr('y', 9)
      .attr('dy', '.35em')
      .style('text-anchor', 'end')
      .text(function (d) { return d })
  }, [
    props.calificacionCalles,
    props.camionesCalados,
    props.height,
    props.width,
    props.yRange,
    props.xRange,
    props.data,
    setCalleDeCalado,
    showOrdenSalida
  ])

  useEffect(() => {
    createChart()
  }, [showOrdenSalida])

  return (
    <Row>
      <Col md={12}>
        <FormControlLabel
          control={
            <Switch
              color='primary'
              name='showOrdenSalida'
              onChange={() => { setShowOrdenSalida(!showOrdenSalida) }}
              checked={showOrdenSalida}
            />
          }
          label='Ver orden de salida'
        />
      </Col>
      <div id='chart-container' className='chart-container' />
    </Row>
  )
}

export default (BarChart)
